import React, { useEffect, useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { DASHBOARD_FILTERS } from "../../../constants/DashboardFilter";
import {
  clearTicketTaskFilters,
  setTicketTaskAllFilters,
} from "../../../store/reducers/TicketTaskFilter";
import { DisplayMsg } from "../../../services/toastService";
import { GetColor } from "../../../utils/array";
import { setUrl } from "../../../handlers";
import {
  setCurrentTab,
  setQuickSearch,
} from "../../../store/reducers/SharedLayoutDataSlice";

const Support = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [assigneeCounts, setAssigneeCount] = useState();
  const [teamCounts, setTeamCount] = useState();
  useEffect(() => {
    LoadSupport();
  }, []);

  const LoadSupport = async () => {
    try {
      document.getElementById("loader").style.display = "block";
      const result = await fetch(setUrl("HOME", "LOADSUPPORTDASHBOARD", true));
      const response = await result.json();
      if (response.status) {
        setAssigneeCount(response.AssigneeCounts);
        setTeamCount(response.TeamCount);
        StatusCountsGraph(response.StatusCounts);
        PriorityCountsGraph(response.PriorityCounts);
      }
      if (
        response?.status === false &&
        response?.Message ===
          "Collection was modified; enumeration operation may not execute."
      ) {
        LoadSupport();
      }
      document.getElementById("loader").style.display = "none";
    } catch (e) {
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const PriorityCountsGraph = (priorityCountData) => {
    const priorityData = priorityCountData;
    const UpdatedPriority = [];
    let PriorityItems = [];
    priorityData.forEach((item, key) => {
      if (item.label !== "") {
        UpdatedPriority.push(item);
      }
    });
    const priorityarray = [];

    if (UpdatedPriority.length === DASHBOARD_FILTERS.PRIORITY_ARRAY.length) {
      UpdatedPriority.forEach((item) => {
        priorityarray.push({ label: item.label, data: item.data });
      });
    } else {
      let medium = true;
      let low = true;
      let high = true;
      let citical = true;
      UpdatedPriority.forEach((item) => {
        if (item.label.toUpperCase() === "MEDIUM") {
          medium = false;
        } else if (item.label.toUpperCase() === "LOW") {
          low = false;
        } else if (item.label.toUpperCase() === "HIGH") {
          high = false;
        } else {
          citical = false;
        }
        priorityarray.push({ label: item.label, data: item.data });
      });
      if (medium) {
        UpdatedPriority.push(DASHBOARD_FILTERS.PRIORITY_ARRAY[0]);
        priorityarray.push({
          label: DASHBOARD_FILTERS.PRIORITY_ARRAY[0].label,
          data: DASHBOARD_FILTERS.PRIORITY_ARRAY[0].data,
        });
      }
      if (low) {
        UpdatedPriority.push(DASHBOARD_FILTERS.PRIORITY_ARRAY[1]);
        priorityarray.push({
          label: DASHBOARD_FILTERS.PRIORITY_ARRAY[1].label,
          data: DASHBOARD_FILTERS.PRIORITY_ARRAY[1].data,
        });
      }
      if (high) {
        UpdatedPriority.push(DASHBOARD_FILTERS.PRIORITY_ARRAY[2]);
        priorityarray.push({
          label: DASHBOARD_FILTERS.PRIORITY_ARRAY[2].label,
          data: DASHBOARD_FILTERS.PRIORITY_ARRAY[2].data,
        });
      }
      if (citical) {
        UpdatedPriority.push(DASHBOARD_FILTERS.PRIORITY_ARRAY[3]);
        priorityarray.push({
          label: DASHBOARD_FILTERS.PRIORITY_ARRAY[3].label,
          data: DASHBOARD_FILTERS.PRIORITY_ARRAY[3].data,
        });
      }
    }
    am4core.useTheme(am4themes_animated);
    const Priorityamchart = am4core.create("supportPriority_count", "PieChart");

    const series = Priorityamchart.series.push(new am4charts.PieSeries());
    series.dataFields.value = "data";
    series.dataFields.category = "label";
    series.labels.template.disabled = true;
    series.ticks.template.disabled = true;

    series.alignLabels = true;
    const rgm = new am4core.RadialGradientModifier();
    rgm.brightnesses.push(0.7, 0.7, 0.7, 0.7, 0.3);
    series.slices.template.fillModifier = rgm;
    series.slices.template.strokeModifier = rgm;
    series.slices.template.strokeOpacity = 0.2;
    series.slices.template.strokeWidth = 4;

    Priorityamchart.legend = new am4charts.Legend();
    series.slices.template.events.on("hit", (event) => {});
    Priorityamchart.legend = new am4charts.Legend();

    // Position legend
    Priorityamchart.legend.position = "left";
    Priorityamchart.legend.fontSize = 14;
    Priorityamchart.legend.labels.template.maxWidth = 145;
    Priorityamchart.logo.disabled = true;
    Priorityamchart.legend.valueLabels.template.position = "left";
    Priorityamchart.legend.valueLabels.template.align = "left";
    Priorityamchart.legend.labels.template.text =
      "[{color}] {data}   {category} ";
    Priorityamchart.legend.valueLabels.template.text = "";
    Priorityamchart.radius = am4core.percent(80);
    Priorityamchart.legend.itemContainers.template.togglable = false;
    Priorityamchart.legend.itemContainers.template.events.on("hit", (ev) => {
      if (
        ev.target.dataItem.dataContext.category.toUpperCase() === "CRITICAL"
      ) {
        ShowSupportData("priority", "Critical");
      } else if (
        ev.target.dataItem.dataContext.category.toUpperCase() === "HIGH"
      ) {
        ShowSupportData("priority", "High");
      } else if (
        ev.target.dataItem.dataContext.category.toUpperCase() === "MEDIUM"
      ) {
        ShowSupportData("priority", "Medium");
      } else {
        ShowSupportData("priority", "Low");
      }
    });

    let label = "Low";

    UpdatedPriority.forEach((item) => {
      const data = UpdatedPriority.find((item) => item.label === label);
      if (label === "Low") {
        label = "Medium";
      } else if (label === "Medium") {
        label = "High";
      } else if (label === "High") {
        label = "Critical";
      }
      PriorityItems.push(data);
    });

    PriorityItems = PriorityItems.reverse();

    Priorityamchart.data = PriorityItems;
    series.colors.list = [
      am4core.color(GetColor(UpdatedPriority[3].color)),
      am4core.color(GetColor(UpdatedPriority[2].color)),
      am4core.color(GetColor(UpdatedPriority[0].color)),
      am4core.color(GetColor(UpdatedPriority[1].color)),
    ];
  };

  const ShowSupportData = (type, value) => {
    dispatch(setQuickSearch(false));
    dispatch(setCurrentTab("tickets"));
    dispatch(clearTicketTaskFilters());
    if (type === "status") {
      dispatch(
        setTicketTaskAllFilters({
          status: value,
          teamCategory: "Support",
          type: "Ticket",
          currentPage: 1,
        })
      );
    } else if (type === "priority") {
      dispatch(
        setTicketTaskAllFilters({
          status: "",
          teamCategory: "Support",
          priority: value,
          type: "Ticket",
          currentPage: 1,
        })
      );
    } else if (type === "assignee") {
      dispatch(
        setTicketTaskAllFilters({
          type: "Ticket",
          teamCategory: "Support",
          category: "Support",
          assignee: value.toUpperCase(),
          currentPage: 1,
          status: "FU",
        })
      );
    } else if (type === "teams") {
      dispatch(
        setTicketTaskAllFilters({
          type: "Ticket",
          team: value,
          teamCategory: "Support",
          status: "FU",
          currentPage: 1,
        })
      );
    }

    navigate("/tickets");
  };

  const StatusCountsGraph = (StatusData) => {
    const statusData = StatusData;
    const statusarray = [];
    const updatedStatus = [];

    if (statusData.length === DASHBOARD_FILTERS.STATUS_ARRAY.length) {
      statusData.forEach((item) => {
        statusarray.push({ label: item.label, data: item.data });
      });
    } else {
      let resolved = true;
      let inProgress = true;
      let pendingOnClient = true;
      let open = true;
      let reopened = true;
      statusData.forEach((item) => {
        if (item.label.toUpperCase() === "RESOLVED") {
          resolved = false;
        } else if (item.label.toUpperCase() === "IN PROGRESS") {
          inProgress = false;
        } else if (item.label.toUpperCase() === "PENDING ON CLIENT") {
          pendingOnClient = false;
        } else if (item.label.toUpperCase() === "OPEN") {
          open = false;
        } else {
          reopened = true;
        }
        statusarray.push({ label: item.label, data: item.data });
      });
      if (resolved) {
        statusData.push(DASHBOARD_FILTERS.STATUS_ARRAY[3]);
        statusarray.push({
          label: DASHBOARD_FILTERS.STATUS_ARRAY[3].label,
          data: DASHBOARD_FILTERS.STATUS_ARRAY[3].data,
        });
      }
      if (inProgress) {
        statusData.push(DASHBOARD_FILTERS.STATUS_ARRAY[1]);
        statusarray.push({
          label: DASHBOARD_FILTERS.STATUS_ARRAY[1].label,
          data: DASHBOARD_FILTERS.STATUS_ARRAY[1].data,
        });
      }
      if (pendingOnClient) {
        statusData.push(DASHBOARD_FILTERS.STATUS_ARRAY);
        statusarray.push({
          label: DASHBOARD_FILTERS.STATUS_ARRAY[4].label,
          data: DASHBOARD_FILTERS.STATUS_ARRAY[4].data,
        });
      }
      if (open) {
        statusData.push(DASHBOARD_FILTERS.STATUS_ARRAY[0]);
        statusarray.push({
          label: DASHBOARD_FILTERS.STATUS_ARRAY[0].label,
          data: DASHBOARD_FILTERS.STATUS_ARRAY[0].data,
        });
      }
    }

    am4core.useTheme(am4themes_animated);
    const Statusamchart = am4core.create("supportStatus_count", "PieChart");

    const series = Statusamchart.series.push(new am4charts.PieSeries());
    series.dataFields.value = "data";
    series.dataFields.category = "label";
    series.labels.template.disabled = true;
    series.ticks.template.disabled = true;

    series.alignLabels = true;
    const rgm = new am4core.RadialGradientModifier();
    rgm.brightnesses.push(0.3, 0.3, 0.3, 0.3, 0);
    series.slices.template.fillModifier = rgm;
    series.slices.template.strokeModifier = rgm;
    series.slices.template.strokeOpacity = 0.2;
    series.slices.template.strokeWidth = 4;

    Statusamchart.legend = new am4charts.Legend();
    series.slices.template.events.on("hit", (event) => {});
    Statusamchart.legend = new am4charts.Legend();

    // Position legend
    Statusamchart.legend.position = "left";
    Statusamchart.legend.fontSize = 14;
    Statusamchart.legend.labels.template.maxWidth = 12;
    Statusamchart.logo.disabled = true;
    Statusamchart.legend.valueLabels.template.position = "left";
    Statusamchart.legend.valueLabels.template.align = "left";
    Statusamchart.legend.labels.template.text =
      "[{color}] {data}   {category} ";
    Statusamchart.legend.valueLabels.template.text = "";
    Statusamchart.legend.itemContainers.template.togglable = false;
    Statusamchart.radius = am4core.percent(90);
    Statusamchart.legend.itemContainers.template.events.on("hit", (ev) => {
      if (ev.target.dataItem.dataContext.category.toUpperCase() === "OPEN") {
        ShowSupportData("status", "O");
      } else if (
        ev.target.dataItem.dataContext.category.toUpperCase() === "RESOLVED"
      ) {
        ShowSupportData("status", "R");
      } else if (
        ev.target.dataItem.dataContext.category.toUpperCase() === "REOPENED"
      ) {
        ShowSupportData("status", "K");
      } else if (
        ev.target.dataItem.dataContext.category.toUpperCase() ===
        "PENDING ON CLIENT"
      ) {
        ShowSupportData("status", "Q");
      } else {
        ShowSupportData("status", "I");
      }
    });

    let label = "Open";

    statusarray.forEach((item) => {
      const data = statusarray.find((item) => item.label === label);
      if (label === "Open") {
        label = "In Progress";
      } else if (label === "In Progress") {
        label = "Pending On Client";
      } else if (label === "Pending On Client") {
        label = "Resolved";
      } else if (label === "Resolved") {
        label = "Reopened";
      }
      updatedStatus.push(data);
    });
    Statusamchart.data = updatedStatus;

    series.colors.list = [
      am4core.color(GetColor(statusData[3].color)),
      am4core.color(GetColor(statusData[1].color)),
      am4core.color(GetColor(statusData[2].color)),
      am4core.color(GetColor(statusData[0].color)),
      am4core.color("#c20001"),
    ];
  };

  const CheckCurrentUser = (username) => {
    const name = `${sessionStorage.firstName} ${sessionStorage.lastName}`;
    if (username === name) {
      return true;
    }
    return false;
  };

  const Assigneelist = (arr) => {
    if (arr != null) {
      const myArray = [];
      arr.forEach((index) => {
        myArray.push(
          <li
            onClick={() => ShowAssignee(index.name)}
            className="py-1 w-50 ps-4"
            role="button"
            key={index.label}
          >
            <span
              className={`${
                CheckCurrentUser(index.name) === true
                  ? "bg-green-800 border-0 text-white"
                  : ""
              } listNumber text-sm`}
            >
              {index.data}
            </span>
            <span className="text-sm">{index.name.toUpperCase()}</span>
          </li>
        );
      });
      return myArray;
    }
  };

  const TeamsList = (data) => {
    if (data != null) {
      const teamArray = [];
      data.forEach((index) => {
        teamArray.push(
          <li
            className="py-1 w-50 ps-4"
            onClick={() => ShowTeams(index.label)}
            key={index.label}
            role="button"
          >
            <span className="listNumber text-sm">{index.data}</span>
            <span className="text-sm">{index.name.toUpperCase()}</span>
          </li>
        );
      });
      return teamArray;
    }
  };

  const ShowAssignee = (name) => {
    ShowSupportData("assignee", name);
  };

  const ShowTeams = (value) => {
    ShowSupportData("teams", value);
  };

  return (
    <>
      <div className="row table-panel-header mb-2">
        <div className="col-md-12 col-sm-12">
          <h6>Support</h6>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 col-sm-12">
          <div className="table-panel">
            <div className="table-panel-header">
              <h6>Counts</h6>
            </div>
            <section id="supportStatus_count" className="pieHeight" />
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="table-panel">
            <div className="table-panel-header">
              <h6>Priority</h6>
            </div>
            <section id="supportPriority_count" className="pieHeight" />
          </div>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-md-6 col-sm-12">
          <div className="table-panel">
            <div className="table-panel-header">
              <h6>Assignees</h6>
            </div>
            <section className="assigneeBox py-2">
              <ul className="d-flex flex-wrap mb-0 list-unstyled">
                {Assigneelist(assigneeCounts)}
              </ul>
            </section>
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="table-panel">
            <div className="table-panel-header">
              <h6>Teams</h6>
            </div>

            <section className="py-2">
              <ul className="d-flex flex-wrap mb-0 list-unstyled">
                {TeamsList(teamCounts)}
              </ul>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Support;
